Librarian.Modules.Nav = new Class({
    Extends: Librarian.Modules.Module,

    options: {
        classPrefix: "modules-nav-",
        pageName: null,
        // Text to label this module with, placed within the container so it can be moved via CSS rather than in the title above the module
        label: null,
        onClick: null
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl || (!this.options.pageName && !this.options.onClick))
            return;

        this.parent();

        this.wrapperEl.addClass("nav-wrapper");
        if (typeof this.options.onClick == "function")
            this.wrapperEl.addOnClick(this.options.onClick.bind(this));
        else {
            this.wrapperEl.addOnClick(function () {
                Librarian.Modules.Nav.navigateToPage(this.options.pageName);
            }, this);
        }

        var label = (this.options.label || '').trim();
        if (label.length > 0) {
            new Element("div", {
                "class": "nav-label",
                "html": Librarian.Lang.getString(label),
                "data-translation": label
            }).injectInside(this.containerEl);
        }
    }
});

Librarian.Modules.Nav.extend({
    navigateToPage: function (pageName) {
        pageName = (pageName|| "").trim().toLowerCase();
        if (pageName.contains("workspace"))
            Library.loadWorkspaceTab();
        else if (["library", "directory"].contains(pageName)) {
            if (pageName == initializer.tab) {
                // If the side column exists but it is collapsed
                if (sideColumn && sideColumn.isCollapsed) {
                    // Find the selected tab
                    var selectedEl = $$("#menuBar li.active")[0];
                    if (selectedEl) {
                        var tab = Library.getTabByName(Librarian.Utils.getElementValue(selectedEl));
                        // If the current tab is the library tab, just show the column
                        if (tab && tab.isLibrary) {
                            if (sideColumn.handleIconEl)
                                sideColumn.handleIconEl.click();
                            else
                                sideColumn.columnToggle();
                            return;
                        }
                    }
                }
            }

            // Load the library tab as a fallback
            Library.loadLibraryTab();
        }
        else
            Library.loadTabByName(pageName, null, null, true);
    }
})